<template>
    <div>
      <video :data-poster="poster" ref="player" controls style="--plyr-color-main:#4b9a5e;" @play="handleVideoPlay"></video>
    </div>
  </template>

  <script>
  import {ref} from 'vue';
  import Plyr from 'plyr';
  import {useEducationStore} from "../../../../stores/EducationStore.js"
  import {useUserStore} from "../../../../stores/UserStore.js"

  export default {
    props: {
      videoSource: String,
      poster: String,
      videoName: String,
    },
    setup(props) {
        return{
            durationTimer:ref(null),
            videoDuration: 0,
            educationStore:useEducationStore(),
            userStore:useUserStore()
        }
    },
    mounted() {
      this.setupPlyr();
      if(!_.isNull(this.videoSource) || !_.isUndefined(this.videoSource)){
            this.player.source = {
                type: 'video',
                title: this.videoName,
                sources: [
                    {
                        src: this.videoSource,
                        type: 'video/mp4',
                    },
                ],
            };
      }
    },
    watch: {
        videoSource(newSrc) {
            this.player.source = {
                type: 'video',
                title: this.videoName,
                sources: [
                    {
                        src: newSrc,
                        type: 'video/mp4',
                    },
                ],
            };
        },
    },
    methods: {
        setupPlyr() {
            // Initialize Plyr with options
            this.player = new Plyr(this.$refs.player, {
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen', 'speed'],
                settings: ['captions', 'quality', 'speed', 'loop']
            });
            const savedVolume = localStorage.getItem('videoVolume');
            if (savedVolume !== null) {
                // Set the saved volume
                this.player.volume = parseFloat(savedVolume);
            }
            const savedDuration = localStorage.getItem('videoDuration');
            const videoName = localStorage.getItem('videoName');
            if (savedDuration !== null && videoName == this.videoName) {
                // Set the saved duration
                this.videoDuration = parseFloat(savedDuration);
                this.player.currentTime = parseFloat(savedDuration)
            }
            this.player.on('play', () => {
                localStorage.setItem('videoName', this.videoName);
            });
            this.player.on('volumechange', () => {
                const volume = this.player.volume;
                localStorage.setItem('videoVolume', volume.toString());
            });
            this.player.on('canplay', () => {
                // Set the currentTime to the desired value from the database
                //this.player.currentTime = this.educationStore.last_played.watched_time;
                if(this.userStore.user.id){
                    this.debouncedUpdateUserVidProgress(this.videoName, this.videoDuration)
                }
            });
            this.player.on('end', () => {
            // Set the currentTime to the desired value from the database
                //this.player.currentTime = this.educationStore.last_played.watched_time;
                if(this.userStore.user.id){
                    this.debouncedUpdateUserVidProgress(this.videoName, this.videoDuration)
                }

            });
            // Listen for duration change and log it
            this.player.on('timeupdate', () => {
                const currentTime = this.player.currentTime;
                this.videoDuration = currentTime;
                localStorage.setItem('videoDuration', currentTime.toString());
                if(this.userStore.user.id){
                    this.debouncedUpdateUserVidProgress(this.videoName, this.videoDuration)
                }
            });
        },
        debouncedUpdateUserVidProgress: _.debounce(function(videoName, currentTime) {
            this.educationStore.updateUserVidProgress(videoName, currentTime);
        }, 1000),
    },
  };
  </script>
<style scope>


</style>



